<template>
  <v-card
    flat
    class="media-card"
    style="
      position: relative;
      border: 1px solid hsl(214.3 31.8% 91.4%);
      border-radius: 0.5rem;
      box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
      display: grid;
      overflow: visible;
      grid-template-rows: auto 30px;
    "
    width="200"
    height="200"
  >
    <div
      class="menu-overlay"
      style="position: absolute; top: 10px; right: 10px; z-index: 1000"
    >
      <v-menu transition="slide-y-transition" bottom width="200px">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            variant="flat"
            color="smokeDark"
            size="x-small"
          >
            <v-icon size="small">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list density="compact">
          <v-list-item link @click="preview(m.src)">
            <v-list-item-title>
              <v-icon size="small" class="mr-3">mdi-open-in-new</v-icon>
              View</v-list-item-title
            >
          </v-list-item>
          <v-list-item link @click="$store.dispatch('deleteMedia', m.uid)">
            <v-list-item-title>
              <v-icon size="small" class="mr-3">mdi-delete</v-icon>
              Delete</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div
      v-if="m.extension === 'pdf'"
      style="
        height: 200px;
        width: 200px;
        overflow: auto;
        position: relative;
        border-radius: 6px;
      "
    >
      <VuePdfEmbed :source="m.src" />
    </div>

    <div v-else-if="m.thumbnail || m.src">
      <v-img
        style="border-radius: 6px"
        :aspect-ratio="16 / 9"
        :src="m.thumbnail || m.src"
        cover
        width="200px"
        height="200px"
      >
      </v-img>
    </div>
  </v-card>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed";

export default {
  props: ["m"],
  components: {
    VuePdfEmbed,
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    preview(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  display: grid;
  grid-template-columns: auto 36px;
  gap: 10px;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.menu-overlay {
  opacity: 0;
  transition: opacity 0.5s ease;
}

.media-card:hover .menu-overlay {
  opacity: 1;
}
</style>
